import { useState, useEffect } from 'react';
import {
  useInstantSearch,
  useRefinementList,
  useToggleRefinement,
} from 'react-instantsearch-hooks-web';
import { Button, FilterSwitch } from '@fagmobler/ui';

import { useStores } from '@/components/store';
import { useNavigation } from '@/contexts/navigation';
import singletonRouter from 'next/router';

export function StockFilterWrapper() {}

export function StockFilter() {
  const { current } = useStores();
  const currentStoreId = current?.data?.store?.id;
  const currentStore = current?.data?.store;

  const { value, canRefine, createURL } = useToggleRefinement({
    attribute: 'storesWithStockOrDisplay',
    on: currentStoreId || undefined,
    off: undefined,
  });

  const { setShowStores } = useNavigation();

  const handleChange = (checked: boolean) => {
    if (checked && currentStoreId && canRefine) {
      // @ts-ignore TODO fix this warning
      singletonRouter.push(createURL('on'), undefined, { shallow: true });
    } else {
      // @ts-ignore TODO fix this warning
      singletonRouter.push(createURL('off'), undefined, { shallow: true });
    }
  };

  // const countForStore = value ? value.onFacetValue.count : 0;
  const isChecked = value ? value.onFacetValue.isRefined : false;

  return (
    <FilterSwitch
      title={'Lagerstatus'}
      onChange={handleChange}
      checked={isChecked}
      disabled={!currentStore || !canRefine}
    >
      <div className="mt-5 ml-5">
        {currentStore?.name && (
          <div>
            <p className="cap-sm">
              Vis kun produkter som {currentStore.name} har på lager.
            </p>
            <button
              className="mt-2 underline cap-link-xs underline-offset-4"
              onClick={() => setShowStores(true)}
            >
              Endre butikk
            </button>
          </div>
        )}

        {!currentStore?.name && <p>Velg butikk for å filtrere på lager</p>}
        {!currentStore && (
          <button
            onClick={() => setShowStores(true)}
            className="mt-2 underline cap-link-xs"
          >
            Velg butikk
          </button>
        )}
      </div>
    </FilterSwitch>
  );
}
